export enum SwatchType {
    HEX = "hex",
    FILE = "file",
    NONE = "none",
}

export interface ISwatch {
    color: string;
    swatch_type: SwatchType;
    value: string;
    modified_on?: Date;
}

export interface ICollectionSwatch extends ISwatch {
    selected?: boolean;
    label?: string;
}
